<template>
  <div
    :class="componentClass"
    :style="componentStyle"
  >
    <label
      :class="labelClass"
      :for="sluggedLabel"
    >
      {{ label }}
    </label>
    <div :class="inputWrapperClass">
      <font-awesome-icon
        v-if="hasIcon && isProcessing"
        :icon="$v7[iconStyle][isProcessingIconName]"
        spin
      />
      <font-awesome-icon
        v-else-if="hasIcon"
        :icon="$v7[iconStyle][iconName]"
      />

      <input
        :id="sluggedLabel"
        v-bind="$attrs"
        ref="field"
        :autofocus="autofocus"
        :class="inputClass"
        :disabled="isDisabled"
        :name="sluggedLabel"
        :placeholder="placeholder"
        :readonly="isReadOnly"
        :required="isRequired"
        :type="type"
        :value="value.value"
        @click="handleClick"
        @input="updateValue"
        @blur="onBlur"
        @focus="$emit('focus')"
        @keydown.enter.prevent="$emit('enter')"
      />
    </div>

    <p
      v-if="tip"
      class="tip margin-top-2xs margin-bottom-0"
    >
      {{ tip }}
    </p>
  </div>
</template>

<script>
  import sluggify from '../../utils/sluggify'

  export default {
    name: 'TextField',

    inheritAttrs: false,

    props: {
      autofocus: {
        type: Boolean,
        default: false
      },
      customStyle: {
        type: Object,
        default: () => {}
      },
      iconPlacement: {
        type: String,
        default: 'before'
      },
      iconName: {
        type: String,
        default: null
      },
      iconStyle: {
        type: String,
        default: 'solid'
      },
      inputClass: {
        type: String,
        default: null
      },
      isDisabled: {
        type: Boolean,
        default: false
      },
      isProcessing: {
        type: Boolean,
        default: false
      },
      isProcessingIconName: {
        type: String,
        default: 'faSpinnerThird'
      },
      isMinimal: {
        type: Boolean,
        default: false
      },
      isReadOnly: {
        type: Boolean,
        default: false
      },
      isRequired: {
        type: Boolean,
        default: true
      },
      isRounded: {
        type: Boolean,
        default: false
      },
      isValid: {
        type: Boolean,
        default: true
      },
      label: {
        type: String,
        required: true
      },
      placeholder: {
        type: String,
        default: null
      },
      tip: {
        type: String
      },
      type: {
        type: String,
        default: 'text'
      },
      value: {
        type: Object,
        default: () => {
          return { valid: true, value: '' }
        }
      }
    },

    computed: {
      componentStyle() {
        return {
          ...this.customStyle
        }
      },

      componentClass() {
        return { danger: !this.isValid }
      },

      hasIcon() {
        return this.iconName
      },

      inputWrapperClass() {
        return [{ 'with-icon-before': this.hasIcon && this.iconPlacement == 'before' }, { 'with-icon-after': this.hasIcon && this.iconPlacement == 'after' }]
      },

      labelClass() {
        return ['margin-bottom-2xs', { 'sr-only': this.isMinimal }]
      },

      sluggedLabel() {
        return sluggify(this.label)
      }
    },

    methods: {
      onBlur(event) {
        this.$emit('blur')
        this.updateValue(event)
      },

      handleClick(event) {
        this.$emit('click', event)
      },

      updateValue(event) {
        this.$emit('input', {
          valid: event.target.validity.valid,
          value: event.target.value
        })

        this.$emit('validity', event.target.validity)
      },

      focus() {
        try {
          this.$refs.field.focus()
        } catch (e) {
          // noop
        }
      }
    }
  }
</script>
